import React, { useContext } from 'react';
import ReportView from '../../../../components/content/analytics/ReportView';
import { regAssociationAnalyticsAndReportsConfig } from '../../../../components/content/analytics/regAssociationAnalyticsAndReportsConfig';
import { Context as RegistrationAdminContext } from '../../../../providers/RegistrationAdminProvider';
import { Context as RegistrationAdminDashboardContext } from '../../../../providers/RegistrationAdminDashboardProvider';

const RegAssociationReportView = () => {
  const { state, generateAdminRegAssociationAnalyticsReport } = useContext(
    RegistrationAdminContext
  );
  const { state: dashboardState } = useContext(
    RegistrationAdminDashboardContext
  );
  const backPath = '/admin/reports';

  return (
    <ReportView
      entityId={dashboardState.regAssociation.value?.pkRegAssociation}
      onGenerateReport={(data, onSuccess, onError) =>
        generateAdminRegAssociationAnalyticsReport(
          dashboardState.regAssociation.value.pkRegAssociation,
          data,
          onSuccess,
          onError
        )
      }
      redirectPath={backPath}
      reportConfigs={regAssociationAnalyticsAndReportsConfig.reports}
      reportResult={state.regAssociationAnalyticsReport.value}
      reportViewType="association"
      resourcesLoading={
        !state.regAssociation.value || state.regAssociation.loading
      }
      urlBase="/admin/reports"
    />
  );
};

export default RegAssociationReportView;
